import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {TimeFormatsEnum} from '../../../../../helpers/dateTimeHelpers';
import {CalendarEventModel} from '../../../../../models/api/calendarEventModel';
import {CalendarEventVersionModel} from '../../../../../models/api/calendarEventVersionModel';
import {CalendarEventTimeFormatter} from '../../../../common/formatters/calendarEventTimeFormatter';
import {CalendarInviteViewerMore} from './calendarInviteViewerMore';

/*
 * Props.
 */

export interface CalendarInviteViewerHeaderProps {
  timeFormat: TimeFormatsEnum;
  calendarEvent: CalendarEventModel;
  calendarEventVersion: CalendarEventVersionModel;
  hasICSAttachments: boolean;
  downloadICSAttachments: Handler;
}

/*
 * Style.
 */

const StyledHeaderDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 4px;
  align-items: center;
  padding: 13px 9px 13px 16px;
  border-bottom: 1px solid ${(p) => p.theme.greys.shade30};
`;

const StyledDetailsDiv = styled.div`
  min-width: 0;
`;

const StyledSummaryDiv = styled.div`
  margin-bottom: 4px;

  color: ${(p) => p.theme.greys.shade80};
  font-weight: ${fontWeights.semibold};
  ${ellipsis()};
`;

const StyledTimeDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  ${ellipsis()};
`;

/*
 * Component.
 */

export const CalendarInviteViewerHeader: FC<CalendarInviteViewerHeaderProps> = (props) => (
  <StyledHeaderDiv>
    <StyledDetailsDiv>
      <StyledSummaryDiv>
        {props.calendarEventVersion.summary || <Trans id="invite-header-untitled">Untitled meeting</Trans>}
      </StyledSummaryDiv>
      <StyledTimeDiv>
        <CalendarEventTimeFormatter
          calendarEventVersion={props.calendarEventVersion}
          timeFormat={props.timeFormat}
        />
      </StyledTimeDiv>
    </StyledDetailsDiv>
    <CalendarInviteViewerMore {...props} />
  </StyledHeaderDiv>
);
